export default {
  setServiceDetails ({ commit }, payload) {
    commit('setServiceDetails', payload)
  }
}
